
import { defineComponent } from "vue";
import FacebookIcon from "@/components/icons/FacebookIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import TwitterIcon from "@/components/icons/TwitterIcon.vue";
import SpotifyIcon from "@/components/icons/SpotifyIcon.vue";

export default defineComponent({
  components: {},
  setup() {
    return {
      instagramURL: "https://www.instagram.com/atlantidamallorcafilmfest/",
      facebookURL: "https://www.facebook.com/atlantidamallorcafilmfest/",
      twitterURL: "https://twitter.com/atlantidafilm",
      spotifyURL:
        "https://open.spotify.com/playlist/53K37PKWE5W4iF6UyCIqxG?si=70465f2ec3df4b05",
      FacebookIcon,
      InstagramIcon,
      TwitterIcon,
      SpotifyIcon,
    };
  },
});
